import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import globals from '@/globals'

// Layouts
import unauthenticated from './unauthenticated'
import main from './main'
import system from './system'
import generalledger from './generalledger'
import humanresource from './humanresource'
import edisbursement from './edisbursement'
import accountspayable from './accountspayable'
import { accessInformation } from '../common/helper'

Vue.use(Router)
Vue.use(Meta)

const ROUTES = [
  // Default route
  { path: '', redirect: '/login' }
]
  .concat(unauthenticated)
  .concat(main)
  .concat(system)
  .concat(generalledger)
  .concat(humanresource)
  .concat(accountspayable)
  .concat(edisbursement)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: ROUTES
})

router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  if (to.meta.unAuth) {
    next()
  } else {
    if (localStorage.getItem('token') === null) {
      next('/login')
    } else {
      let accConf = accessInformation('SC') // Show Confirmation
      if (to.path !== '/confirmation' && accConf === '1') {
        next('/confirmation')
      } else {
        next()
      }
    }
  }
  // Set loading state
  document.body.classList.add('app-loading')

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
